import React from 'react'
import { Tag } from 'lucide-react'
import { StatsCard } from './stats/StatsCard'
import { formatCompactNumber } from '@/utils'
import type { MonthlyAvgDataPoint } from '@/types/otc'
import { buildChartSeries } from './charts/otcSeries'

interface AssetsOnDiscountCardProps {
  assetsOnDiscount: number
  loading?: boolean
  monthlyAvg?: MonthlyAvgDataPoint[]
  label?: string
}

const AssetsOnDiscountChart: React.FC<{ monthlyAvg?: MonthlyAvgDataPoint[]; seed: number }> = ({ monthlyAvg, seed }) => {
  const heights = buildChartSeries({
    source: monthlyAvg,
    count: 21,
    min: 16,
    max: 100,
    seed,
  })

  return (
    <div className="relative h-full w-full max-w-[214px]">
      <div className="absolute bottom-0 left-0 flex h-[100px] w-full items-end gap-1">
        {heights.map((height, index) => (
          <div
            key={`bar-${index}`}
            className="flex-1 rounded-full bg-[#c8ed03]"
            style={{ height: `${height}px` }}
          />
        ))}
      </div>
    </div>
  )
}

export const AssetsOnDiscountCard: React.FC<AssetsOnDiscountCardProps> = ({
  assetsOnDiscount,
  loading = false,
  monthlyAvg,
  label = 'Assets on Discount',
}) => {
  return (
    <StatsCard
      icon={<Tag className="h-4 w-4" strokeWidth={1.8} />}
      iconAlt="Assets on Discount"
      label={label}
      value={formatCompactNumber(assetsOnDiscount)}
      loading={loading}
      mobileHeight="h-[126px]"
      chart={<AssetsOnDiscountChart monthlyAvg={monthlyAvg} seed={assetsOnDiscount} />}
    />
  )
}
